module.exports = __webpack_public_path__ + "static/img/acc-1.f3840f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acc-1.png
// module id = 9ug1
// module chunks = 1